import { MenuItem } from '@mui/material';

import styled from 'styled-components';

export const StyledMenuItem = styled(MenuItem)`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 143%;
  letter-spacing: 0.17px;
  width: 100%;
`;

export const Wrapper = styled.div`
  margin-top: 20px;
  border-radius: 0 0 8px 8px;
  background: ${({ theme }) => theme.palette.common.white};
  display: flex;
  padding: 20px;
  flex-direction: column;
`;

export const Header = styled.h1`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 20px;
  font-weight: 400;
  padding: 0;
  margin: 0;
`;

export const Description = styled.p`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 16px;
  line-height: 24px;
  padding: 0;
  margin: 0;
`;

export const InputLabel = styled.label`
  display: block;
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  font-weight: 500;
  padding: 0;
  margin: 0;
  margin-top: 20px;
`;

export const Warning = styled.div`
  display: flex;
  padding: 4px 16px;
  align-items: center;
  align-self: stretch;
  border-radius: 4px;
  background: ${({ theme }) => theme.toast.warning.background};
  gap: 8px;
  margin-top: 20px;

  p {
    color: ${({ theme }) => theme.palette.warning.dark};
    font-size: 16px;
    font-weight: 500;
    margin: 8px 0;
    padding: 0;
  }
`;
